import styled from 'styled-components/macro';

export const Container = styled.div`
  height: 100%;
  padding: 20px 50px;
  width: 100%;
  max-width: 1600px;
  margin-bottom: 80px;
`;

export const BannerBox = styled.div`
  margin-bottom: 40px;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .images {
    .ant-image {
      margin-bottom: 20px;
    }
  }
`;

export const UploadButton = styled.label``;

export const UploadContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
